// Session Management Configuration
// Matches your backend JWT token settings: 1.5 hours + 30 min grace period

export const SESSION_CONFIG = {
    // Backend JWT Token Settings
    JWT_TOKEN_DURATION: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
    JWT_GRACE_PERIOD: 30 * 60 * 1000, // 30 minutes grace period
    JWT_TOTAL_DURATION: 7 * 24.5 * 60 * 60 * 1000, // 7 days 0.5 hours total (7 days + 0.5 hrs grace)
    
    // Frontend Session Settings
    FRONTEND_TIMEOUT: 15 * 60 * 1000, // 15 minutes on inactivity
    WARNING_THRESHOLD: 2 * 60 * 1000, // Show warning 2 minutes before expiry
    ACTIVITY_EXTENSION: 15 * 60 * 1000, // Extend by 15 minutes on activity
    
    // Heartbeat Settings
    HEARTBEAT_INTERVAL: 5 * 60 * 1000, // Call verifyToken API every 5 minutes
    HEARTBEAT_RETRY_DELAY: 30 * 1000, // Retry failed heartbeat after 30 seconds
    
    // Activity Tracking
    ACTIVITY_EVENTS: [
      'mousedown', 'mousemove', 'keypress', 'scroll', 
      'touchstart', 'click', 'focus', 'blur'
    ],
    
    // Debug Settings
    ENABLE_LOGGING: process.env.NODE_ENV === 'development',
    LOG_PREFIX: '[SessionManager]',
  };
  
  // Helper functions for time calculations
  export const TimeUtils = {
    // Convert minutes to milliseconds
    minutes: (minutes: number) => minutes * 60 * 1000,
    
    // Convert hours to milliseconds
    hours: (hours: number) => hours * 60 * 60 * 1000,
    
    // Get remaining time in minutes
    getRemainingMinutes: (expiryTime: number) => {
      const remaining = expiryTime - Date.now();
      return Math.max(0, Math.floor(remaining / (60 * 1000)));
    },
    
    // Check if time is within threshold
    isWithinThreshold: (expiryTime: number, threshold: number) => {
      const remaining = expiryTime - Date.now();
      return remaining > 0 && remaining <= threshold;
    },
    
    // Format time for display
    formatTime: (milliseconds: number) => {
      const minutes = Math.floor(milliseconds / (60 * 1000));
      const seconds = Math.floor((milliseconds % (60 * 1000)) / 1000);
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
  };
  
  // Session state constants
  export const SESSION_STATES = {
    ACTIVE: 'active',
    WARNING: 'warning',
    EXPIRED: 'expired',
    REFRESHING: 'refreshing',
  } as const;
  
  export type SessionState = typeof SESSION_STATES[keyof typeof SESSION_STATES];